import { getObjectTypedKeys } from './object-entries';
export function filterObject(inputObject, callback) {
    const filteredKeys = getObjectTypedKeys(inputObject).filter((key) => {
        const value = inputObject[key];
        return callback(key, value, inputObject);
    });
    return filteredKeys.reduce((accum, key) => {
        accum[key] = inputObject[key];
        return accum;
    }, {});
}
export function omitObjectKeys(inputObject, omitTheseKeys) {
    return filterObject(inputObject, (currentKey) => {
        return !omitTheseKeys.includes(currentKey);
    });
}
export function pickObjectKeys(inputObject, pickTheseKeys) {
    return filterObject(inputObject, (currentKey) => {
        return pickTheseKeys.includes(currentKey);
    });
}
